// extracted by mini-css-extract-plugin
export default {"systemGeneratingResponse":"style_systemGeneratingResponse__f780F","spin":"style_spin__X5w1l"};